import { BuildTypeCode } from '../projects/project';
import { PipeResponse } from '../shared/pipes/pipeResponse';
import { DataForQuoteOrDesignForm } from '../shared/quote-or-design-form/GetDataForQuoteOrDesignForm';
import { ThermostatTypeCode } from '../shared/quote-or-design-form/quoteOrDesignFormData';
import { mapUnitResponseToFormModel, UnitResponse } from '../shared/units/unitResponse';
import { DesignFormModel } from './design-form/designFormModel';

export type DesignResponse = {
  designId: number;
  createdFromQuoteId: number;
  underfloorHeatingSalesOrderId: number | null;
  heatPumpSalesOrderId: number | null;
  solarSalesOrderId: number | null;
  isDraft: boolean;
  fullName: string;
  title: string;
  revisionCode: string;
  revisionReason: string;
  qrNumber: string;
  address: string;
  defaultThermostatTypeCode: ThermostatTypeCode;
  includeNeoHub: boolean;
  units: Array<UnitResponse>;
  pipes: Array<PipeResponse>;
};

export const mapDesignResponseToFormModel = (
  designResponse: DesignResponse,
  referenceData: DataForQuoteOrDesignForm,
  projectBuildType: BuildTypeCode,
): DesignFormModel => ({
  designId: designResponse.designId,
  title: designResponse.title,
  revisionCode: designResponse.revisionCode,
  revisionReason: designResponse.revisionReason,
  qrNumber: designResponse.qrNumber,
  address: designResponse.address,
  underfloorHeatingSalesOrderId: designResponse.underfloorHeatingSalesOrderId,
  heatPumpSalesOrderId: designResponse.heatPumpSalesOrderId,
  solarSalesOrderId: designResponse.solarSalesOrderId,
  isDraft: designResponse.isDraft,
  defaultThermostatTypeCode: designResponse.defaultThermostatTypeCode,
  includeNeoHub: designResponse.includeNeoHub,
  units: designResponse.units.map(unitResponse =>
    mapUnitResponseToFormModel({
      unitResponse,
      referenceData,
      projectBuildType,
      mapRoomlessManifoldDetailsToRoom: false,
      createDesignDetails: false,
    }),
  ),
  focusedUnitId: null,
  unitsValidation: null,
});
